import { api } from "./client";
import type { TokenOut, UserProfile } from "@/types/api";

export interface AuthOptions {
  host_login_available: boolean;
  cesium_ion_token: string | null;
}

export function getAuthOptions() {
  return api.get<AuthOptions>("/api/auth/options");
}

export function loginRequest(username: string, password: string) {
  return api.post<TokenOut>("/api/auth/login", { username, password });
}

export function hostLoginRequest() {
  return api.post<TokenOut>("/api/auth/login/host");
}

export function logoutRequest() {
  return api.post<{ message: string }>("/api/auth/logout");
}

export function getCurrentUser() {
  return api.get<UserProfile>("/api/auth/me");
}

export function registerRequest(
  username: string,
  password: string,
  account_type: "pilot" | "instructor" = "pilot",
) {
  return api.post<UserProfile>("/api/auth/register", {
    username,
    password,
    account_type,
  });
}
